import createModel from "../createModel";

export const RssItem = createModel("RssItem", (json) => ({
    title: json.title,
    link: json.link,
    thumbnail: json.thumbnail,
    description: json.description,
}));
